var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIconTrial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4124 7.55833H11.0653C11.5815 7.55833 11.9999 7.99214 12 8.52736V9.11682V15.8416V16.4311C12 16.9663 11.5815 17.4001 11.0653 17.4001H5.99998H0.934674C0.418444 17.4001 0 16.9663 0 16.4311V15.8416V9.11682V8.52736C0 7.99217 0.418444 7.55836 0.934674 7.55836H1.58769H3.16207H5.99995H8.83806V5.17454C8.83806 3.55209 7.56503 2.23231 5.99995 2.23231C5.80441 2.23231 5.61332 2.25296 5.42883 2.29223C5.05964 2.37074 4.71643 2.5238 4.41437 2.73547C4.2634 2.84129 4.12266 2.96185 3.99421 3.09501C3.48032 3.62777 3.16207 4.36332 3.16207 5.17454V7.55836H1.58769V5.17454C1.58769 2.65225 3.56709 0.600166 6.00008 0.600098C8.43304 0.600098 10.4124 2.65221 10.4124 5.1745V7.55833ZM5.39879 12.7247L5.06356 14.3806H6.93634L6.60118 12.7247C6.91458 12.5179 7.12393 12.1568 7.12393 11.7431C7.12393 11.0996 6.62076 10.5779 5.99995 10.5779C5.37917 10.5779 4.87597 11.0996 4.87597 11.7431C4.87597 12.1569 5.08535 12.5179 5.39879 12.7247Z",
    fill: "#413F5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconTrial);
export default __webpack_public_path__ + "static/media/LockIconTrial.f87ddbf3adfc31b35fff4b96f4561470.svg";
export { ForwardRef as ReactComponent };